// Catálogo pt-BR dos textos de sistema: mensagens que se repetem entre telas, estados genéricos (carregando, vazio,
// erro), validações e os rótulos de situação provisória/ambiente. Textos próprios de uma tela ficam nela.
// Padrão editorial: docs/reviews/WEB_CONTENT_AUDIT.md · reescritas: docs/reviews/CONTENT_REWRITES.md.
// tests/content/content-lint.unit.test.ts recusa expressões genéricas, emojis e referências internas na interface.

export const MSG = {
  common: {
    loading: 'Carregando',
    checkingSession: 'Verificando sessão',
    select: 'Selecione…',
    noRecords: 'Nenhum registro encontrado.',
    noRecordsPeriod: 'Nenhum registro encontrado para o período selecionado.',
    retry: 'Tentar novamente',
    back: 'Voltar',
    cancel: 'Cancelar',
    save: 'Salvar',
    confirm: 'Confirmar',
    saving: 'Salvando…',
  },
  errors: {
    network: 'Sem conexão com o servidor. Verifique a internet e tente novamente.',
    download: 'Não foi possível baixar o arquivo. Tente novamente.',
    unexpected: 'Não foi possível concluir a operação. Tente novamente.',
    validation: 'Alguns dados não foram aceitos pelo servidor. Revise os campos e tente novamente.',
    rateLimited: 'Muitas tentativas em pouco tempo. Aguarde um minuto e tente novamente.',
    /** The request id lets support find the server log entry without exposing internals. */
    server: (requestId?: string) =>
      `Não foi possível concluir a operação por uma falha no servidor. Tente novamente${
        requestId ? `; se persistir, informe ao suporte o código ${requestId.slice(0, 8)}` : ''
      }.`,
    noReportAccess: 'Seu perfil não tem acesso aos relatórios financeiros.',
  },
  validation: {
    negative: 'Informe um valor maior ou igual a zero.',
    money: 'Valor inválido. Use o formato 1.234,56.',
    quantity: 'Informe uma quantidade inteira maior ou igual a zero.',
    quantityRange: 'Quantidade acima do limite permitido.',
    reason: (min: number) => `Informe a justificativa com pelo menos ${min} caracteres.`,
    reasonMissing: (missing: number) =>
      `Faltam ${missing} ${missing === 1 ? 'caractere' : 'caracteres'} para a justificativa mínima.`,
    reasonOk: 'Justificativa com o tamanho mínimo.',
  },
  /** Figures that depend on an open business decision (docs/03-decision-register.md). */
  provisional: {
    badge: 'Regra provisória',
    title:
      'Regra de cálculo provisória: aguarda a decisão da Operação e do Financeiro (D-02/D-03). Use os valores para homologação, não para decisão.',
    suffix: '(regra provisória)',
  },
  environment: {
    label: 'Ambiente',
    /** ENVIRONMENT_LABEL values written for people. */
    names: {
      HOMOLOGACAO: 'Homologação',
      DESENVOLVIMENTO: 'Desenvolvimento',
      PRODUCAO: 'Produção',
      E2E: 'Teste automatizado',
    } as Record<string, string>,
    synthetic: 'dados de teste; regras de cálculo provisórias',
    offline: 'SEM CONEXÃO — apenas rascunhos neste dispositivo',
  },
  update: {
    available: 'Há uma nova versão do sistema. Salve o que estiver editando antes de atualizar.',
    apply: 'Atualizar agora',
  },
  /** Password field (login, forced change, set-password page). */
  password: {
    show: 'Mostrar senha',
    hide: 'Ocultar senha',
    capsLock: 'Caps Lock ativado',
  },
  /** Profile names for role codes; the same words the API uses in e-mails and the demo accounts. */
  roles: {
    OPERADOR: 'Operação',
    CONFERENTE: 'Conferência',
    FINANCEIRO: 'Financeiro',
    GESTOR: 'Gestão',
    ADMIN: 'Administração de TI',
  } as Record<string, string>,
} as const;
